import React from 'react';
import { Link } from 'react-router-dom';

import styles from './Card.module.scss';

interface Props {
  clickHandler: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseEnter: (e: React.MouseEvent<HTMLAnchorElement> | React.FocusEvent<HTMLAnchorElement>) => void;
  onMouseLeave: () => void;
  link: string;
  imageHeight: number;
  itemWidth: number;
  children: React.ReactNode;
  handleLinkRef: React.MutableRefObject<null>;
  isMosaicProgram: boolean;
  ariaLabel?: string | undefined;
}

export function Card({
  handleLinkRef,
  clickHandler,
  onMouseEnter,
  onMouseLeave,
  link,
  itemWidth,
  imageHeight,
  children,
  isMosaicProgram,
  ariaLabel,
}: Props) {
  const state = {
    lastScrollYPosition: window.scrollY + imageHeight,
    isShowStreams: isMosaicProgram,
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        minHeight: imageHeight,
        width: itemWidth,
      }}
    >
      <Link
        className={styles.link}
        onClick={clickHandler}
        aria-label={ariaLabel}
        onMouseOver={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onFocus={onMouseEnter}
        onBlur={onMouseLeave}
        role='link'
        tabIndex={0}
        ref={handleLinkRef}
        to={link}
        state={state}
      >
        {children}
      </Link>
    </div>
  );
}
